<template>
    <!-- 预览试卷 -->
    <div class="board">
        <div v-hasPermi="['questionBank:testPaper:info']" class="h100p">
            <div class="title">
                <span><el-button type="text" icon="el-icon-arrow-left" @click="back(false)">{{ testPaperTextConfig.back }}</el-button><el-divider
                        direction="vertical"></el-divider><span class="name">{{ title }}</span></span>
            </div>
            <div class="questionCon" v-loading="loading" element-loading-text="加载中"
                 element-loading-spinner="el-icon-loading">
                <div class="left" v-if="questionNum>0" @scroll="scrollEvent">
                    <el-card class="box-card" shadow="hover" style="margin-bottom: 18px" v-if="isHaveIntroduction()">
                        <div>
                            <div style="font-size: 16px; font-weight: bold">竞赛说明</div>
                            <hr>
                            <div v-html="introduction" style="max-height: 300px; overflow-y: auto">
                            </div>
                        </div>
                    </el-card>

                    <div v-for="(item,index) in question" :key="index+key">
                        <el-card class="box-card" :id="'module'+index" shadow="hover" v-if="item.question_num>0">
                            <div slot="header" class="unClearfix">
                                <span>{{ item.name }}</span>
                                <span>{{ testPaperTextConfig.questionTypeTip.signMix(item.question_num, item.total_score) }}</span>
                            </div>
                            <div class="questionModle" :id="'module'+index+'question'+i"
                                 v-for="(e,i) in item.question_list" :key="i">
                                <span>{{ i + 1 }}.</span>
                                <p v-html="e.newStem" class="ql-editor"></p>
                                <div v-if="e.crosshead">
                                    <div v-for="(n,l) in e.crosshead" :key="l">
                                        <span class="questionIndex">（{{ l + 1 }}）</span>
                                        <p v-html="n.newStem" class="ql-editor"
                                           style="display:inline-block;max-width:calc(100% - 45px)"></p>
                                    </div>
                                </div>
                                <p style="margin:10px 0">
                                    <el-tag v-if="e.attachment.stem" @click="questionStatus(index,i)" size="medium"><a
                                            :href="config_env.BASE_URL+getDownloadAddress(e.attachment.stem.file_path,e.attachment.stem.file_name)"
                                            target="_blank"><i class="el-icon-download"></i> {{
                                        testPaperTextConfig.attachment }}
                                        {{ e.attachment.stem.file_name }}</a></el-tag>
                                </p>
                                <el-button
                                        v-if="trainingEnable && item.question_type == 'subjectivity' && e.training_id"
                                        @click="questionStatus(index,i),seeShare(e)" type="primary" size="mini"
                                        icon="el-icon-monitor" style="margin:10px 0 0">{{ e.training_label }}
                                </el-button>
                                <div v-if="item.question_type != 'fill' && item.question_type != 'subjectivity'">
                                    <el-radio-group v-model="e.answer[0]" @change="questionStatus(index,i)"
                                                    v-if="item.question_type == 'single_choice'">
                                        <el-radio v-for="(f,j) in e.choices" :key="j" :label="j" style="display:block;">
                                            <i>{{ letter[j] }} .&nbsp;&nbsp;</i><span v-html="f" class="ql-editor"
                                                                                      style="display:inline-flex"></span>
                                        </el-radio>
                                    </el-radio-group>
                                    <el-radio-group v-model="e.answer[0]" @change="questionStatus(index,i)"
                                                    v-if="item.question_type == 'determine'" class="determine">
                                        <el-radio :label="1">{{ testPaperTextConfig.determine.right }}</el-radio>
                                        <el-radio :label="0">{{ testPaperTextConfig.determine.error }}</el-radio>
                                    </el-radio-group>
                                    <el-checkbox-group v-model="e.answer"
                                                       @change="checkboxChange(e.answer),questionStatus(index,i)"
                                                       v-if="item.question_type == 'choice' || item.question_type == 'uncertain_choice'">
                                        <el-checkbox v-for="(f,j) in e.choices" :key="j" :label="j"
                                                     style="display:block;"><i>{{ letter[j] }} .&nbsp;&nbsp;</i><span
                                                v-html="f" class="ql-editor" style="display:inline-flex"></span>
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div class="questAnswer">
                                    <span class="questLabel"
                                          :style="item.question_type == 'subjectivity'?'margin-top:13px;':''"
                                          v-if='item.question_type != "subjectivity" || (e.submit_mode && e.submit_mode.length >0 && (e.submit_mode.includes("text")|| (e.submit_mode.length == 1&& e.submit_mode.includes("attachment"))))'>{{ testPaperTextConfig.yourAnswer }}：</span>
                                    <div v-if="item.question_type == 'subjectivity' && e.submit_mode && e.submit_mode.includes('text')"
                                         class="subjectivity">
                                        <div v-if="e.crosshead.length>0">
                                            <div v-for="(n,l) in e.crosshead" :key="l"
                                                 style="margin-bottom:10px !important">
                                                <span class="questIndex">（{{ (l + 1) }}）&nbsp;</span>
                                                <quill-editor :value.sync="e.answer[l]"
                                                              @focus="questionStatus(index,i)"
                                                              :placeholder="testPaperTextConfig.crossheadAnswerTip.signMix(l+1)"
                                                              style="display:inline-block;width:calc(100% - 48px);margin-top:7px"></quill-editor>
                                            </div>
                                        </div>
                                        <quill-editor v-else @focus="questionStatus(index,i)"
                                                      :value.sync="e.answer[0]"
                                                      :placeholder="testPaperTextConfig.answerTip"
                                                      style="margin-bottom:10px !important;margin-top:6px"></quill-editor>
                                    </div>
                                    <div v-if="item.question_type == 'subjectivity' && e.submit_mode && e.submit_mode.includes('link')"
                                         style="clear:both;">
                                        <span style="margin-top:13px;width: 80px;display: inline-block;">{{testPaperTextConfig.link}}：</span>
                                        <div class="subjectivity" style="margin-top:10px">
                                            <el-input v-model="e.link"
                                                      :placeholder="testPaperTextConfig.linkTip"></el-input>
                                        </div>
                                    </div>
                                    <div v-if="item.question_type == 'subjectivity' " class="subjectivity">
                                        <el-button
                                                v-if="e.submit_mode && e.submit_mode.includes('attachment') && e.submit_mode.length > 1"
                                                @click="questionStatus(index,i)"
                                                disabled size="mini" type="primary" icon="el-icon-paperclip"
                                                style="margin-top:10px;margin-left:80px">{{
                                            testPaperTextConfig.uploadTip }}
                                        </el-button>
                                        <el-button
                                                v-if="e.submit_mode && e.submit_mode.includes('attachment') && e.submit_mode.length == 1"
                                                @click="questionStatus(index,i)"
                                                disabled size="mini" type="primary" icon="el-icon-paperclip"
                                                style="margin-top:10px;">{{ testPaperTextConfig.uploadTip }}
                                        </el-button>
                                    </div>
                                    <p v-else-if="item.question_type == 'fill'"
                                       style="display:inline-block;width:calc(100% - 80px);margin-top:-6px;">
                                        <el-input v-for="(an,a) in e.answer" @focus="questionStatus(index,i)" :key="a"
                                                  v-model.trim="e.answer[a]" clearable
                                                  :placeholder="testPaperTextConfig.answerTip2.signMix(a+1)"
                                                  style="margin:2px 10px 0 0;width:250px"></el-input>
                                    </p>
                                    <span v-else style="font-size:16px">
                                        {{ item.question_type == 'single_choice' ? letter[e.answer] : (item.question_type == 'choice' || item.question_type == 'uncertain_choice' || item.question_type == 'determine' ? change(e.answer, item.question_type) : '') }}
                                    </span>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </div>
                <div class="right" v-if="questionNum>0" :style="confirmPreview ? 'height:calc(100% - 24px)' : ''">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span>{{ cardTextConfig.name }}</span>
                            <span>{{ cardTextConfig.answered }} {{ okNum }}/{{ questionNum }}</span>
                        </div>
                        <div class="questionButtons">
                            <div v-for="(item,index) in question" :key="index" v-show="item.question_num>0"
                                 style="margin-bottom:6px">
                                <a @click="questionStatus(index,0, 'module')" style="padding-bottom:5px">{{ item.name
                                    }}</a>
                                <div>
                                    <span v-for="(e,i) in item.question_list" :key="i+key" class="questionButton">
                                        <a @click="questionStatus(index,i, 'question')"><el-button
                                                :type="e.type" style="width:100%">{{ i + 1 }}</el-button></a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </el-card>
                    <el-button v-if="paperPreview"
                               @click="$router.push({name:'testPaperEdit',query:{id:$route.query.id,name:$route.query.name}})"
                               type="primary" style="width:100%" :disabled="status == 1">{{
                        cardButtonTextConfig.edit.name }}
                    </el-button>
                    <el-button v-if="showConfirmNext" @click="confirmNext" type="primary" style="width:100%"
                               :disabled="confirmBtn">{{ cardButtonTextConfig.next.name }}
                    </el-button>
                    <el-button v-if="!showConfirmNext && confirmPreview" @click="back(true)" type="primary"
                               style="width:100%"
                               :disabled="confirmBtn || index !== paperData.examPaperIdList.length - 1">{{
                        cardButtonTextConfig.confirm.name }}
                    </el-button>
                    <p class="info" v-if="showConfirmNext">{{ cardButtonTextConfig.confirm.tip1 }}</p>
                    <p class="info" v-if="!showConfirmNext && confirmPreview">{{ cardButtonTextConfig.confirm.tip2
                        }}</p>
                </div>
                <div class="questionCon emptyFlex" v-else>
                    <el-empty :description="testPaperTextConfig.nullTip" :image-size="180">
                        <br/>
                        <el-button v-if="paperPreview"
                                   @click="$router.push({name:'testPaperEdit',query:{id:$route.query.id,name:$route.query.name}})"
                                   type="primary" :disabled="status == 1">{{ cardButtonTextConfig.edit.name }}
                        </el-button>
                        <el-button v-if="showConfirmNext" @click="confirmNext" type="primary">{{
                            cardButtonTextConfig.next.name }}
                        </el-button>
                        <el-button v-if="!showConfirmNext && confirmPreview" @click="back(true)" type="primary"
                                   :disabled="confirmBtn || index !== paperData.examPaperIdList.length - 1">{{
                            cardButtonTextConfig.confirm.name }}
                        </el-button>
                    </el-empty>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import quillEditor from '@/components/editor/index.vue'
    import {getDownloadAddress} from '@/utils/common.js'
    import {certaintyPaper} from "@/api/questionBank";

    export default {
        components: {
            quillEditor
        },
        props: ['paperPreview'],
        data() {
            return {
                loading: true,
                title: '',
                introduction: '',
                questionNum: 0,
                questionScore: 0,
                letter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
                question: [],
                key: 0,
                status: 0,
                okNum: 0,
                confirmBtn: true,
                index: 0,
            }
        },
        computed: {
            trainingEnable() {
                return this.$store.state.global.textConfig.training.enable
            },
            testPaperTextConfig() {
                return this.$store.state.global.textConfig.backend.arrangement.paperConfig.table.button.setPaper.testPaper
            },
            cardTextConfig() {
                return this.testPaperTextConfig.card
            },
            cardButtonTextConfig() {
                return this.cardTextConfig.button
            },
            showConfirmNext() {
                return this.confirmPreview && this.paperData.examPaperIdList.length > 1 && this.index < this.paperData.examPaperIdList.length - 1
            },
            confirmPreview() {
                let show = this.$store.state.arrangeExam.confirmPreview
                if (show) {
                    let examPaperId = this.paperData.examPaperIdList[this.index]
                    this.initExamPaper(examPaperId)
                }
                return show
            },
            paperData() {
                return this.$store.state.arrangeExam.confirmPaperData
            }
        },
        created() {
            if (this.paperPreview) {
                this.title = this.testPaperTextConfig.previewTitle + '：' + this.$route.query.name
                let id = this.$route.query.id
                this.getPaper(id)
            }
        },
        methods: {
            isHaveIntroduction() {
                if (this.introduction) {
                    return this.introduction.replace(/<\/?[^>]+(>|$)/g, "")
                } else {
                    return false
                }
            },
            confirmNext() {
                this.confirmBtn = true
                this.index += 1
                // let examPaperId = this.paperData.examPaperIdList[this.index]
                document.getElementsByClassName('questionCon')[0].getElementsByClassName('left')[0].scrollTo(0, 0)
                // this.initExamPaper(examPaperId)
            },
            initExamPaper(examPaperId) {
                this.loading = true
                this.$store.dispatch('getConfirmExamPaper', examPaperId).then(res => {
                    if (res.status === 200) {
                        this.title = this.testPaperTextConfig.title.signMix(res.data.name)
                        let question = res.data.confirmed_paper
                        for (let i = 0; i < question.length; i++) {
                            this.resetQuestionList(question[i])
                        }
                        this.introduction = res.data.introduction
                        this.questionNum = res.data.question_num
                        this.questionScore = res.data.total_score
                        setTimeout(() => {
                            this.question = question
                            this.key += 1
                            this.loading = false

                            this.$nextTick(() => {
                                let e = document.getElementsByClassName('left')[0]
                                if (e && this.confirmPreview && e.scrollHeight <= e.clientHeight) {
                                    this.confirmBtn = false
                                }
                            })
                        }, 300);
                    }
                })
            },
            getDownloadAddress,
            change(answer, type) {
                if (type == 'choice' || type == 'uncertain_choice') {
                    let arr = []
                    if (answer) {
                        for (let i = 0; i < answer.length; i++) {
                            const j = answer[i]
                            arr.push(this.letter[j])
                        }
                    }

                    return arr.join('、')
                } else if (type == 'determine') {
                    if (answer[0] === 0) {
                        return this.testPaperTextConfig.determine.error
                    } else if (answer[0] === 1) {
                        return this.testPaperTextConfig.determine.right
                    } else {
                        return ''
                    }
                }
            },
            checkboxChange(val) {
                return val.sort()
            },
            back(val) {
                if (this.paperPreview) {
                    this.$router.push('/testPaper')
                } else {
                    if (val) {
                        let paperData = Object.assign({}, this.paperData)
                        // 确认配置试卷
                        certaintyPaper(this.paperData.examPaperIdList).then(res => {
                            if (res.status == 200) {
                                this.$store.dispatch("putExamPaper", paperData).then(res2 => {
                                    if (res2.status == 200) {
                                        this.$store.state.arrangeExam.confirmPreview = false
                                        this.$message({
                                            message: '已更新',
                                            type: 'success'
                                        });
                                        this.$emit("saved", true)
                                    }
                                });
                            }
                        })
                    } else {
                        this.$store.state.arrangeExam.isBack = true
                        this.$store.state.arrangeExam.confirmPreview = false
                    }
                }
            },
            seeShare(e) {
                let name = localStorage.getItem("1+XUserIdentity");
                this.$store.dispatch("getTrainingInstanceSrc", e.training_id).then(res => {
                    if (res.status == 200) {
                        let routeUrl = this.$router.resolve({
                            path: "/practicalTraining",
                            query: {
                                name,
                                time: null,
                                trainingMirror: e.training_id,
                                questionId: e.id,
                                reviewMode: e.review_mode
                            }
                        });
                        window.open(routeUrl.href, '_blank');
                    }
                })
            },
            questionStatus(index, n, type) {

                if (type) {
                    const parent = document.querySelector('.left');
                    if (type === 'module') {
                        const child = document.querySelector(`#module${index}`);
                        parent.scrollTo({top: (child.offsetParent.offsetTop + child.offsetTop - 180), behavior: "smooth"});
                    } else if (type === 'question') {
                        const child = document.querySelector(`#module${index}question${n}`);
                        parent.scrollTo({top: (child.offsetParent.offsetParent.offsetTop + child.offsetParent.offsetTop + child.offsetTop - 180), behavior: "smooth"});
                    }
                }

                let num = 0
                for (let i = 0; i < this.question.length; i++) {
                    const list = this.question[i].question_list;
                    for (let j = 0; j < list.length; j++) {
                        const e = list[j];
                        let isOk = true
                        if (e.answer.length > 0) {
                            for (let k = 0; k < e.answer.length; k++) {
                                const f = e.answer[k];
                                if (f === '') isOk = false
                            }
                        } else {
                            isOk = false
                        }
                        if (isOk) {
                            num += 1
                            e.type = 'success'
                        } else {
                            e.type = ''
                        }
                    }
                }
                this.okNum = num
                // if (index === 0 || index > 0) {
                //     console.log(this.question[index].question_list[n].type);
                //     this.question[index].question_list[n].type = 'primary'
                // }
                this.question[index].question_list[n].type = 'primary'
            },
            scrollEvent(e) {
                e.stopPropagation()
                if (this.confirmPreview) {
                    if (Math.ceil(e.currentTarget.scrollTop + e.currentTarget.clientHeight) >= e.currentTarget.scrollHeight) {   //容差：20px
                        // console.log('滚动到底部');
                        this.confirmBtn = false
                    }
                }
            },
            resetQuestionList(question) {
                let list = question.question_list;
                for (let n = 0; n < list.length; n++) {
                    let li = list[n];
                    if (!li.attachment) {
                        li.attachment = {}
                    }
                    li.link = ""
                    li.answer = ['']
                    let stem = li.stem
                    if (stem.indexOf('</p>') != -1) {
                        li.newStem = stem.slice(0, -4) + `<span class="el-tag el-tag--info el-tag--mini scoreTag">${li.score}分</span></p>`
                    } else {
                        li.newStem = stem + `<span class="el-tag el-tag--info el-tag--mini scoreTag">${li.score}分</span>`
                    }
                    if (question.question_type == 'subjectivity') {
                        if (li.crosshead) {
                            li.answer = []
                            for (let o = 0; o < li.crosshead.length; o++) {
                                let f = li.crosshead[o]
                                let str = f.stem
                                if (str.indexOf('</p>') != -1) {
                                    f.newStem = str.slice(0, -4) + `<span class="el-tag el-tag--info el-tag--mini scoreTag">${f.score}分</span></p>`
                                } else {
                                    f.newStem = str + `<span class="el-tag el-tag--info el-tag--mini scoreTag">${f.score}分</span>`
                                }
                                li.answer.push('')
                            }
                            this.key += 1
                        } else {
                            li.crosshead = []
                        }
                    } else if (question.question_type == 'fill') {
                        li.answer = []
                        li.newStem = li.stem
                        var reg = RegExp(/\[\[(.*?)\]\]/);
                        regExpFun(1)

                        function regExpFun(x) {
                            if (li.newStem.match(reg)) {
                                let str = '______(' + x + ')______'
                                li.newStem = li.newStem.replace(/\[\[(.*?)\]\]/, str)
                                li.answer.push('')
                                regExpFun(x + 1)
                            } else {
                                return
                            }
                        }
                    } else if (question.question_type == 'choice' || question.question_type == 'uncertain_choice') {
                        li.answer = []
                    }
                }
            },
            getPaper(id) {
                this.$store.dispatch("getPaperPreview", id).then(res => {
                    let question = res.data.test_paper_section_list
                    let isSuccess = [];
                    question.forEach(() => {
                        isSuccess.push(false)
                    })
                    for (let i = 0; i < question.length; i++) {
                        const mId = question[i].id;
                        this.$store.dispatch("getPaperModlePreview", {id, mId}).then(resData => {
                            question[i].question_list = resData.data.question_list
                            this.resetQuestionList(question[i])
                            isSuccess[i] = true
                            // 所有请求完成后，渲染试题
                            if (isSuccess.indexOf(false) === -1) {
                                this.showQuestion(question)
                            }
                        });
                    }
                    this.introduction = res.data.introduction
                    this.questionNum = res.data.question_num
                    this.questionScore = res.data.total_score
                    this.status = res.data.status
                });
            },
            showQuestion(question) {
                this.question = question
                this.key += 1
                this.loading = false
            }
        }
    }
</script>

<style scoped>
    .questionIndex {
        float: left;
        line-height: 32px;
    }

    .info {
        color: #c0c4cc;
        text-align: center;
        line-height: 28px;
        font-size: 12px;
    }
</style>
